export default () => {
    return [
        {
            path: '/tabellaQualita',
            name: 'tabellaQualita',
            component: () => import('./views/tabellaQualita.vue'),
        },
    ];
};
